import { CloudActions, AdminUrls } from '@portal/portal-core';

import { sendAction } from 'api';
import type { WrappedHttpResult } from 'api';
import { AuthClientUtils } from 'ducks/auth-client';
// 'Config' vite alias has no tsconfig path mapping; import the aliased module (src/Config.js) via relative path. Untyped .js -> serverUrl is any.
import { serverUrl } from '../../../../Config';

const fetchUsersByIds = async (ids: string[]): Promise<WrappedHttpResult> => {
  const url = AdminUrls.adminClientUrl(serverUrl);
  const action = CloudActions.adminGetUsersByIds(ids);
  const authToken = AuthClientUtils.getAuthToken();
  return sendAction({ url, action, authToken });
};

export default fetchUsersByIds;
